import axios from "axios";
export default {
  getAll(context, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`search/?query=${params}`)
        .then((response) => {
          context.commit("setBooks", response.data.books);
          context.commit("setCourses", response.data.courses);
          context.commit("setConferences", response.data.conferences);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
